<template>
  <router-link
    v-if="currentItem && currentItem.card"
    :to="`/projekt/${currentItem.card.path}`"
    class="nu nl"
  >
    <div class="hero is-fullwidth is-large has-background">
      <img
        v-show="ready"
        :key="currentItem.card.uid"
        :alt="currentItem.card.title"
        class="hero-background is-transparent
        hero-sm custom-img"
        :class="{ 'fade-in': ready }"
        :src="`${$helpers.url}image/${currentItem.images[0].name}?size=2000`"
        @load="
          ready = true;
          $emit('ready');
        "
      />

      <div class="hero-body np">
        <div
          class="slider-navigation-next is-hidden-mobile"
          @click.stop.prevent="
            Clear();
            ChangeImage();
          "
        >
          <svg viewBox="0 0 50 80" xml:space="preserve">
            <polyline
              fill="currentColor"
              stroke-width=".5em"
              stroke-linecap="round"
              stroke-linejoin="round"
              points="0.375,0.375 45.63,38.087 0.375,75.8 "
            />
          </svg>
        </div>
        <div
          class="slider-navigation-previous is-hidden-mobile"
          @click.stop.prevent="
            Clear();
            ChangeImage(true);
          "
        >
          <svg viewBox="0 0 50 80" xml:space="preserve">
            <polyline
              fill="currentColor"
              stroke-width=".5em"
              stroke-linecap="round"
              stroke-linejoin="round"
              points="45.63,75.8 0.375,38.087 45.63,0.375 "
            />
          </svg>
        </div>

        <div class="container is-hidden-touch">
          <div class="bg-grey has-text-white mini-rounded">
            <h1
              v-if="currentItem && currentItem.card.title"
              class="title has-text-light"
            >
              {{ currentItem.card.title }}
            </h1>
            <h2
              v-if="currentItem && currentItem.card.subtitle"
              class="subtitle has-text-light"
            >
              {{ currentItem.card.subtitle }}
            </h2>
          </div>
        </div>
      </div>
    </div>
  </router-link>
</template>

<style scoped>
.slide-fade-enter-active {
  transition: all 1s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(15px);
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.custom-img {
  object-fit: cover;
}

.fade-in {
  -webkit-animation: fadein 1s; /* Safari, Chrome and Opera > 12.1 */
  -moz-animation: fadein 1s; /* Firefox < 16 */
  -ms-animation: fadein 1s; /* Internet Explorer */
  -o-animation: fadein 1s; /* Opera < 12.1 */
  animation: fadein 1s;
}

@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Firefox < 16 */
@-moz-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Internet Explorer */
@-ms-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Opera < 12.1 */
@-o-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>

<script>
export default {
  components: {},
  props: ["link", "items"],
  data() {
    return {
      ready: false,
      currentItem: null,
      interval: null,
      currentIndex: -1,
      maxIndex: 0,
      images: [],
      watcherEnabled: true,
    };
  },
  watch: {
    items: function(val) {
      this.maxIndex = this.items.length - 1;
      this.ChangeImage();
      this.interval = setInterval(() => {
        this.ChangeImage();
      }, 4000);
    },
  },
  created() {},
  mounted() {},
  beforeDestroy() {
    this.Clear();
  },
  methods: {
    Clear() {
      clearInterval(this.interval);
    },

    ChangeImage(prev) {
      this.$nextTick(() => {
        this.ready = false;
        if (prev && this.currentIndex != 0) {
          this.currentIndex = this.currentIndex - 1;
        } else {
          this.currentIndex = this.currentIndex + 1;
        }

        if (this.currentIndex > this.maxIndex || this.currentIndex < 0) {
          this.currentIndex = 0;
        }

        this.currentItem = this.items[this.currentIndex];
      });
    },
  },
};
</script>
